import { useState, useEffect, useCallback } from 'react';

var useLocalStorage = function () {
    var _a = useState(false), canUseLocalStorage = _a[0], setCanUseLocalStorage = _a[1];
    var _b = useState(false), isDoneTesting = _b[0], setIsDoneTesting = _b[1];
    useEffect(function () {
        try {
            localStorage.setItem("test", "test");
            localStorage.removeItem("test");
            setCanUseLocalStorage(true);
        }
        catch (e) {
            console.error("LocalStorage test failed.");
        }
        setIsDoneTesting(true);
    }, []);
    var localStorageGet = useCallback(function (key) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseLocalStorage) {
            console.error("Unable to use localStorage");
        }
        return localStorage.getItem(key);
    }, [canUseLocalStorage, isDoneTesting]);
    var localStorageSet = useCallback(function (key, value) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseLocalStorage) {
            console.error("Unable to use localStorage");
        }
        localStorage.setItem(key, value);
    }, [canUseLocalStorage, isDoneTesting]);
    var localStorageRemove = useCallback(function (key) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseLocalStorage) {
            console.error("Unable to use localStorage");
        }
        localStorage.removeItem(key);
    }, [canUseLocalStorage, isDoneTesting]);
    return {
        canUseLocalStorage: canUseLocalStorage,
        localStorageRemove: localStorageRemove,
        localStorageGet: localStorageGet,
        localStorageSet: localStorageSet,
    };
};

var useSessionStorage = function () {
    var _a = useState(false), canUseSessionStorage = _a[0], setCanUseSessionStorage = _a[1];
    var _b = useState(false), isDoneTesting = _b[0], setIsDoneTesting = _b[1];
    useEffect(function () {
        try {
            sessionStorage.setItem("test", "test");
            sessionStorage.removeItem("test");
            setIsDoneTesting(true);
            setCanUseSessionStorage(true);
        }
        catch (e) {
            setIsDoneTesting(true);
            console.error("SessionStorage test failed");
        }
    }, []);
    var sessionStorageGet = useCallback(function (key) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseSessionStorage) {
            console.error("Unable to use sessionStorage");
        }
        return sessionStorage.getItem(key);
    }, [canUseSessionStorage, isDoneTesting]);
    var sessionStorageSet = useCallback(function (key, value) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseSessionStorage) {
            console.error("Unable to use sessionStorage");
        }
        sessionStorage.setItem(key, value);
    }, [canUseSessionStorage, isDoneTesting]);
    var sessionStorageRemove = useCallback(function (key) {
        if (!isDoneTesting) {
            return;
        }
        if (!canUseSessionStorage) {
            console.error("Unable to use sessionStorage");
        }
        sessionStorage.removeItem(key);
    }, [canUseSessionStorage, isDoneTesting]);
    return {
        canUseSessionStorage: canUseSessionStorage,
        sessionStorageRemove: sessionStorageRemove,
        sessionStorageGet: sessionStorageGet,
        sessionStorageSet: sessionStorageSet,
    };
};

export { useLocalStorage, useSessionStorage };
//# sourceMappingURL=index.js.map
